//convert DateTime to the Date format that we need
export function parseDate(input: string) {
  var parts = input.match(/(\d+)/g)!;
  // console.log(parts, "parts");
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
}

export function convertDatetoTime(input: string) {
  const localDate = new Date(input);
  const hours = localDate.getHours() || "";
  const minutes = localDate.getMinutes();
  const seconds = localDate.getSeconds();
  return ` ${hours}:${minutes}:${seconds} AEDT`;
}

//convert seconds to hours mintues seconds format
export function toHoursAndMinutes(totalSeconds: number) {
  const totalMinutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours !== 0) {
    // return `${hours}h ${minutes}m ${seconds}s`;
    return `${hours}:${minutes}:${seconds}`;
  } else {
    return `${minutes}:${seconds}`;
  }
}

export function toHoursAndMinutesVideoPlayPage(totalSeconds: number) {
  const totalMinutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours !== 0) {
    // return `${hours}h ${minutes}m ${seconds}s`;
    return `${hours} hour ${minutes} min ${seconds} sec`;
  } else {
    return `${minutes} min ${seconds} sec`;
  }
}
